import { useQuery } from 'react-query';

import { ApiRequestError, getUnpublishedExpertRegistrations } from '../../../../../services/api';
import { queryKeys } from '../../../../../utils/react-query';

export const useGetUserRegistrations = () => {
  const { data, isLoading, error, refetch } = useQuery<
    Awaited<ReturnType<typeof getUnpublishedExpertRegistrations>>,
    ApiRequestError
  >([queryKeys.userExpertRegistrations], getUnpublishedExpertRegistrations);

  return { isLoading, data, error, refetch };
};
